// config/index.js
const env = process.env.NODE_ENV;
const configObj = {
  production: {
    // baseUrl: "http://47.101.220.89:8687/" // 打包后的访问地址
    baseUrl: "https://report.wdczn.cn:8666/"
  },
  development: {
    // baseUrl: 'http://47.101.220.89:8687/' // 本地访问地址
    // baseUrl: 'https://3h714z9315.oicp.vip/' // 测试地址
    // baseUrl: "http://192.168.2.182:8080/"
    baseUrl: "https://report.wdczn.cn:8666/"
  }
};

export default { ...configObj[env] };



// WEBPACK FOOTER //
// ./src/utils/config.js